import { render } from "./AgentLoginView.vue?vue&type=template&id=66caabb4&scoped=true"
import script from "./AgentLoginView.vue?vue&type=script&lang=js"
export * from "./AgentLoginView.vue?vue&type=script&lang=js"

import "./AgentLoginView.vue?vue&type=style&index=0&id=66caabb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66caabb4"]])

export default __exports__